module.exports = __webpack_public_path__ + "img/Skirt-Back-B2-Da-Ga-Ha-Ia.643186e2.png";